/* eslint-disable camelcase */
const pt_br = {
    values: {
        Horário: 'Time',
        horário: 'time'
    }
}
module.exports = pt_br
